
/**
 * Default theme values for transcript editor components
 */
export const defaultTheme = {
  colors: {
    text: '#f3e9d7',
    textSecondary: '#a9a9a9',
    background: '#1e1e2c',
    backgroundSecondary: '#2a2a3c',
    border: '#4a4a6a',
    highlight: '#f2d093',
    active: '#4c9aff',
    selection: 'rgb(73, 128, 241)',
  },
  fontSizes: {
    small: '12px',
    regular: '14px',
    medium: '16px',
    large: '18px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
  },
};